module.exports = __webpack_public_path__ + "static/media/ruby.7f8df11b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/ruby.jpeg
// module id = 294
// module chunks = 0